export const CRYPTO_USD_PER_CREDIT = 0.001;
export const CRYPTO_PASS_THROUGH_MARGIN = 3;
export const CRYPTO_VOICE_MARGIN = 1.1;
export const CRYPTO_CHAT_CREDITS_PER_USD = CRYPTO_PASS_THROUGH_MARGIN / CRYPTO_USD_PER_CREDIT;

// Crypto sprite prices are their own list. They do not follow Stripe credit_pricing.
// Flat credits added to a new character or scenario on the full site.
// create_character_step1 keeps the same 30 in SQL.
export const CREATION_FLAT_CREDITS = 30;

export const CRYPTO_SPRITE_PRICES = {
  image_base_anime: 15,
  image_base_realism: 30,
  image_lora_surcharge: 15,
  video_lowres_base: 150,
  video_hd_base: 150,
  video_lora_surcharge: 23,
  video_duration_anchor_seconds: 4,
  video_duration_anchor_credits: 120,
  video_credit_per_extra_second: 30,
};

export const CRYPTO_PACKS = {
  pack_9: { usd: 9, credits: 9000, label: '9,000 credits' },
  pack_19: { usd: 19, credits: 20900, label: '20,900 credits' },
  pack_39: { usd: 39, credits: 46800, label: '46,800 credits' },
  pack_99: { usd: 99, credits: 128700, label: '128,700 credits' },
};

export const cryptoUsdToCredits = (usd, margin = CRYPTO_PASS_THROUGH_MARGIN) => {
  const cost = Number(usd);
  const factor = Number(margin);
  if (!Number.isFinite(cost) || cost <= 0 || !Number.isFinite(factor) || factor <= 0) return 0;
  const credits = Math.round(cost * (factor / CRYPTO_USD_PER_CREDIT) * 100) / 100;
  return Math.max(0.01, credits);
};
